import { RouterManager } from '@aclass/admin/managers';
import { SystemStory } from '@aclass/admin/storage/actions';
import { IAdminState, ISystemModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class SystemStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:system-init';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ISystemModuleState['initialized']>(['systemModule', 'initialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(SystemStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.ngRdx.dispatch(SystemStory.switchApplication(route.data.application || null));
        this.ngRdx.dispatch(SystemStory.dryRun());
    }
}
